import { render, staticRenderFns } from "./purchasePackage.vue?vue&type=template&id=1825f170&scoped=true&"
import script from "./purchasePackage.vue?vue&type=script&lang=js&"
export * from "./purchasePackage.vue?vue&type=script&lang=js&"
import style0 from "./purchasePackage.vue?vue&type=style&index=0&id=1825f170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825f170",
  null
  
)

export default component.exports